module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-drawer"
  }, [_c('div', {
    staticClass: "mask",
    class: _vm.show ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideMask.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "drawer",
    staticClass: "drawer",
    class: [_vm.pos != 'left' ? 'drawer-right' : 'drawer-left', _vm.show ? 'active' : '']
  }, [_vm._t("drawer")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1bcc946","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SliderBar.vue
// module id = 511
// module chunks = 39